/* unplugin-vue-components disabled */import { render } from "./style3.vue?vue&type=template&id=7ae2b3dd&scoped=true"
import script from "./style3.vue?vue&type=script&lang=js"
export * from "./style3.vue?vue&type=script&lang=js"

import "./style3.vue?vue&type=style&index=0&id=7ae2b3dd&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ae2b3dd"]])

export default __exports__